export const parseDateValue = value => {
    if (!value) return { date: null, hasTime: false }

    if (value instanceof Date) {
        return { date: new Date(value.getTime()), hasTime: true }
    }

    if (typeof value === 'string') {
        const [datePart, timePart] = value.split(',').map(part => part.trim())

        if (!datePart) return { date: null, hasTime: false }

        const [day, month, year] = datePart
            .split('.')
            .map(part => Number.parseInt(part, 10))

        if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
            return { date: null, hasTime: false }
        }

        let hours = 0
        let minutes = 0
        let hasTime = false

        if (timePart) {
            const [parsedHours, parsedMinutes] = timePart
                .split(':')
                .map(part => Number.parseInt(part, 10))

            if (
                !Number.isNaN(parsedHours) &&
                !Number.isNaN(parsedMinutes)
            ) {
                hours = parsedHours
                minutes = parsedMinutes
                hasTime = true
            }
        }

        return {
            date: new Date(year, month - 1, day, hours, minutes),
            hasTime,
        }
    }

    return { date: null, hasTime: false }
}

export const buildEndDatetime = (timeMode, duration, date) => {
    if (timeMode === 'duration' && duration?.value !== null) {
        return new Date(Date.now() + duration.value * 1000).toISOString()
    }

    if (timeMode === 'date' && date) {
        const { date: parsedDate, hasTime } = parseDateValue(date)

        if (parsedDate && !Number.isNaN(parsedDate.getTime())) {
            if (!hasTime) {
                parsedDate.setHours(23, 59, 59, 999)
            }
            return parsedDate.toISOString()
        }

        throw new RangeError('Invalid date value received')
    }

    return null
}
